module.exports = __webpack_public_path__ + "img/parking_3.8e420582.jpeg";